import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefHistoryOBGyHistoryEventsDuringARTDetailByID = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryEventsDuringART/GetDetail?` + params, null);

export const GetRefHistoryOBGyHistoryEventsDuringARTList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryEventsDuringART/GetList?` + params, null);

export const CreateRefHistoryOBGyHistoryEventsDuringART = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryEventsDuringART/Create`, data);

export const UpdateRefHistoryOBGyHistoryEventsDuringART = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryEventsDuringART/Update`, data);

export const DeleteRefHistoryOBGyHistoryEventsDuringART = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryEventsDuringART/Delete`, data);